import "./freshchatWidget.scss";

const WIDGET_SRC = "https://fw-cdn.com/11173628/3890651.js";

const loadFreshchatWidget = (): void => {
  const script = document.createElement("script");
  script.src = WIDGET_SRC;
  script.setAttribute("chat", "true");
  document.body.appendChild(script);
};

window.addEventListener("load", loadFreshchatWidget);

export {};
